import { getEnvdDocuments } from "./root";

export const getEnvdById =
  (eNvdId: string) =>
  (state: State): EnvdDocument | null =>
    getEnvdDocuments(state)[eNvdId] || null;
